import { Flex, styled, TextV2, css } from '@withjoy/joykit';
import { ellipsis, filledButtonStates } from '@apps/admin/routes/Dashboard/common/commonDasboard.styles';

export const Container = styled(Flex)`
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm2}) {
    height: 100vh;
  }
`;

export const DashboardHeader = styled(Flex)`
  background: ${({ theme }) => theme.colors.white};
  column-gap: 1rem;
  justify-content: space-between;
  margin-bottom: 1rem;
  position: relative;
  width: 100%;
  padding: 2rem 1.5rem 0 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    column-gap: 1.5rem;
    margin-bottom: 0.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    column-gap: 2.5rem;
    padding: 2.5rem 1.5rem 0 2.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm4}) {
    column-gap: 2rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    column-gap: 2.5rem;
    margin-bottom: 0.5rem;
  }
`;

export const TitleStyled = styled(TextV2)`
  ${({ theme }) => theme.typography.variants.HedMobile32};
  align-items: center;
  display: flex;
  line-height: 2.2rem;
  text-transform: capitalize;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    ${({ theme }) => theme.typography.variants.Hed38};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    ${({ theme }) => theme.typography.variants.Hed48};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm4}) {
    ${({ theme }) => theme.typography.variants.Hed38};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    ${({ theme }) => theme.typography.variants.Hed48};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    ${({ theme }) => theme.typography.variants.Hed56};
  }
`;

export const AdminMenuContainer = styled.div`
  min-width: 6rem;
`;

export const HeaderLine = styled.span`
  ${ellipsis()};
  font-family: 'Austin News Headline';
`;

export const Metadata = styled(Flex)`
  gap: 0.5rem;
  margin-bottom: 2rem;
  padding: 0 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: 2.5rem;
    padding: 0 2.5rem 0 3rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm4}) {
    margin-bottom: 2rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-bottom: 2.5rem;
  }
`;

export const metadataBase = css`
  ${({ theme }) => theme.typography.variants.label1};
  ${filledButtonStates};
  align-items: center;
  background-color: ${props => props.theme.colors.mono2};
  border-radius: 0.25rem;
  column-gap: 0.4rem;
  display: flex;
  justify-content: center;
  padding: 0.375rem 0.75rem;

  svg {
    height: 1rem;
    width: 1rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    ${({ theme }) => theme.typography.variants.button3};
  }
`;

export const MetadataItem = styled.a`
  ${metadataBase}
`;

export const MetadataLocationItem = styled(MetadataItem)`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    display: flex;
  }
`;

export const MetadataSiteItem = styled.button`
  ${metadataBase}
  svg {
    transform: rotate(-90deg);
  }
`;

export const NavigationContent = styled.div`
  flex: 1;
  overflow: hidden;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm2}) {
    display: flex;
  }
`;

export const SectionContainer = styled.div<{
  isBottomDrawerVisible: boolean;
}>`
  overflow: hidden;
  padding: ${({ isBottomDrawerVisible }) => (isBottomDrawerVisible ? '0 1.5rem 200px' : '0 1.5rem 3rem')};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
    flex-direction: column;
    flex: 1;
    max-height: 43.75rem;
    overflow-y: auto;
    padding: 0 2.5rem 3rem 3rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    max-height: 50rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    max-height: 62.5rem;
  }
`;

export const NavigationRow = styled.section`
  display: flex;
  flex-direction: column;
  padding: 0;
  flex: 1;
  flex-grow: inherit;
`;

export const NavigationRowTitle = styled(Flex)`
  align-items: center;
  column-gap: 0.5rem;
  margin-bottom: 0.625rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    margin-bottom: 0.5rem;
  }
`;

export const NavigationContainer = styled.nav`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}) {
    margin-bottom: 1rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: 1.75rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm2}) {
    margin-bottom: 1rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-bottom: 1.9rem;
  }
`;

export const NavigationTitle = styled(TextV2)`
  ${({ theme }) => theme.typography.variants.hed1};

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    ${({ theme }) => theme.typography.variants.hed2};
  }
`;

export const ValuePropositionContainer = styled(Flex)``;
